import { ThematicPracticeCard, type PracticeIllustration } from "@/components/ThematicPracticeCard";

type Practice = {
  title: string;
  description: string;
  illustration: PracticeIllustration;
};

const PRACTICES: Practice[] = [
  { title: "Self-Love", description: "Cultivate kindness towards yourself", illustration: "heart-in-hands" },
  { title: "Calm", description: "Breathe and find your center", illustration: "calm" },
  { title: "Love Life", description: "Tune into your loving energy", illustration: "holding-hands" },
  { title: "Career", description: "Grow professional confidence", illustration: "laptop" },
  { title: "Motivation", description: "Move forward with intention", illustration: "team" },
  { title: "Sport", description: "Build strength in body and mind", illustration: "snickers" },
  { title: "Money", description: "Cultivate an abundance mindset", illustration: "money" },
  { title: "Creativity", description: "Unlock your creative potential", illustration: "creativity" },
  { title: "Study", description: "Sharpen your focus and recall", illustration: "studies" },
];

export function ThematicPracticesCarousel({
  className,
  layout = "square",
}: {
  className?: string;
  layout?: "square" | "row";
}) {
  // Duplicate the list so the translate animation can loop seamlessly.
  const loop = [...PRACTICES, ...PRACTICES];
  const shape =
    layout === "row"
      ? "w-full h-[260px]"
      : "aspect-square w-full";
  return (
    <div
      className={`group/marquee relative overflow-hidden rounded-[24px] ${shape} ${className ?? ""}`}
    >
      <div className="flex h-full items-center">
        <div className="flex w-max animate-marquee-rtl items-center gap-4 px-3 [animation-play-state:running] group-hover/marquee:[animation-play-state:paused] [&:has(*:active)]:[animation-play-state:paused]">
          {loop.map((p, i) => (
            <div
              key={`${p.title}-${i}`}
              className="shrink-0"
              {...(i >= PRACTICES.length ? { "aria-hidden": true, "data-nosnippet": true } : {})}
            >
              <ThematicPracticeCard
                title={p.title}
                description={p.description}
                duration="3 min"
                illustration={p.illustration}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ThematicPracticesCarousel;